import React, { useState } from 'react';
import { DateTime } from 'luxon';
import { useSelector, useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/pro-solid-svg-icons';

// components
import SelectAgentModal from '../common/SelectAgentModal';
import AgentFilter from './AgentFilter';
import { SlideoutModal, Table, LoaderButton } from '../../common/components';

// actions / utils
import { showPopup } from '../../utils/popup';
import { reassignShoppers } from '../../actions/shopper';

function SelectedLeadsModal({ handleLoadShoppers = () => {} }) {
  const dispatch = useDispatch();
  const [ loading, setLoading ] = useState(false);
  const { selectedLeadsModal } = useSelector(store => store.modals);
  const {
    selectedLeads,
    reassignAgent = {},
  } = useSelector(store => store.leads);

  const toDateString = (date) => DateTime.fromISO(date).toLocaleString(DateTime.DATE_SHORT);
  const formatDateCell = (date) => (date ? toDateString(date) : <span className="text-muted">--</span>);
  const formatEmailCell = (email) => (email || <i className="text-muted">Not Available</i>);
  const formatLeadTypeOrSource = (desc) => (desc || <i className="text-muted">Not Set</i>);

  function formatRemoveCell(data) {
    return (
      <FontAwesomeIcon
        role="button"
        icon={faTrash}
        onClick={() => dispatch({ type: 'REMOVE_SELECTED_LEAD', username: data.username })}
      />
    );
  }

  // table schema
  const schema = {
    cols: [
      {
        header: 'Remove',
        passAllData: true,
        formatter: formatRemoveCell,
      },
      {
        header: 'Agent Email',
        field: 'agent_email',
        formatter: formatEmailCell,
        alphaSortIcon: true,
        defaultSortOrder: 'asc',
      },
      {
        header: 'Lead ID',
        field: 'lead_id',
        alphaSortIcon: true,
        defaultSortOrder: 'asc',
      },
      {
        header: 'Lead Type',
        field: 'lead_type',
        formatter: formatLeadTypeOrSource,
        alsphaSortIcon: true,
      },
      {
        header: 'Lead Source',
        field: 'lead_source',
        formatter: formatLeadTypeOrSource,
        alsphaSortIcon: true,
      },
      {
        header: 'Created',
        field: 'created',
        formatter: formatDateCell,
      },
    ],
  };

  function handleReassignment() {
    setLoading(true);
    const leadIDs = selectedLeads.map(l => l.lead_id);
    const agentUsername = reassignAgent.username;
    reassignShoppers({ leadIDs, agentUsername })
      .then(() => {
        dispatch({
          type: 'SET_LEADS_KEYS',
          payload: {
            selectedLeads: [],
            agentFilter: {},
            reassignAgent: {},
          },
        });
        handleLoadShoppers({ agentUsername: '*' });
        dispatch({ type: 'CLOSE_MODAL', modal: 'selectedLeadsModal' });
        showPopup('Succcess!', 'Successfully reassigned leads', 'success');
      }).finally(() => setLoading(false));
  }

  return (
    <SlideoutModal
      isOpen={selectedLeadsModal}
      closeModalAction={() => dispatch({ type: 'CLOSE_MODAL', modal: 'selectedLeadsModal' })}
    >
      <div className="row">
        <div className="col-md-4">
          <AgentFilter
            label="Reassign to Agent"
            openModal={() => dispatch({ type: 'OPEN_MODAL', modal: 'selectReassignAgentModal' })}
            clearSelection={() => dispatch({ type: 'SET_LEADS_KEYS', payload: { reassignAgent: {} } })}
            inputValue={`${reassignAgent.first_name || ''} ${reassignAgent.last_name || ''}`}
          />
        </div>

        <div className="d-flex col-md-4 align-items-end justify-content-end">
          <LoaderButton
            text="Process Reassignment"
            loadingText="Processing"
            loading={loading}
            className="btn btn-danger"
            onClick={() => handleReassignment()}
            disabled={!reassignAgent.username}
          />
        </div>
      </div>

      <hr className="my-4" />

      <div className="row">
        <div className="col">
          <Table
            className="table table-striped"
            schema={schema}
            data={selectedLeads}
          />
        </div>
      </div>
      <SelectAgentModal
        title="Select an Agent to Reassign Leads to"
        modalName="selectReassignAgentModal"
        handleAgentSelect={(agent) => dispatch({ type: 'SET_LEADS_KEYS', payload: { reassignAgent: agent } })}
      />
    </SlideoutModal>
  );
}

export default SelectedLeadsModal;
